/*!jslint
  this
*/
jQuery(function ($) {
  "use strict";
    $(this).scrollTop(0);
    $(document).on('click', '.nav-toggle', function (e) {
      $('html').toggleClass('nav-open');
    });

    if($('.peloader').length){      
        setTimeout(function() {
          $('.peloader').fadeOut();
          $('html').addClass('loaded');          
        }, 2400);
        new Vivus('loadsvg', {type: 'scenario'}, function() {});

    }

    function extendMagnificIframe(){
      
      var $start = 0;
      var $iframe = {
          markup: '<div class="mfp-iframe-scaler">' +
                  '<div id="iframeId" class="mfp-close"></div>' +
                  '<iframe class="mfp-iframe" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>' +
                  '</div>' +
                  '<div class="mfp-bottom-bar">' +
                  '<div class="mfp-title"></div>' +
                  '</div>',
          patterns: {
              vimeo: {
                  index: 'vimeo.com/', 
                  id: function(url) {        
                      var m = url;
                      //if ( !m || !m[5] ) return null;
                      return m;
                  },
                  src: '%id%'
              }
          }
      };

      return $iframe;     

    }

    $('.video-popup').magnificPopup({
      type: 'iframe',
      iframe: extendMagnificIframe()
    });
    function appHeight(){
    var wh = $(window).innerHeight();
      document.documentElement.style
      .setProperty('--app-height', wh+'px');
      
    }
    window.addEventListener('resize', appHeight)
    appHeight();

    $('.hero-image-cl').slick({
      dots: true,
      infinite: true,
      speed: 300,
      slidesToShow: 1,
      fade: true,
      arrows: true,
      autoplay: true,
      autoplaySpeed: 5000,
      prevArrow: "<span class='slick-prev slick-arrow'><svg width='20' height='20' viewBox='0 0 20 20' xmlns='http://www.w3.org/2000/svg' version='1.1' preserveAspectRatio='xMinYMin'><use xlink:href='#img-icn-prev'></use></svg></span>",
      nextArrow: "<span class='slick-next slick-arrow'><svg width='20' height='20' viewBox='0 0 20 20' xmlns='http://www.w3.org/2000/svg' version='1.1' preserveAspectRatio='xMinYMin'><use xlink:href='#img-icn-next'></use></svg></span>",
    });

    $(window).on('load', function () {
      AOS.refresh();
    });
    $(function () {
        AOS.init({
            easing: 'ease-in-out-sine',
            duration: 400,
            once: true
        });
    });
    
    $(".image-comapre").twentytwenty({default_offset_pct: 0.8});

    $(document).on('click', '.rt-tgr', function(e){
      e.preventDefault();
      $(this).parent().find('a').removeClass('active');
      $(this).addClass('active');
      var OW = $(this).parents('.image-comapre-main').outerWidth();
      var OH = $(this).parents('.image-comapre-main').outerHeight();
      $(this).parents('.image-comapre-main').find('.twentytwenty-before').css('clip',  'rect(0px, 0px, '+OH+'px, 0px)');
      $(this).parents('.image-comapre-main').find('.twentytwenty-after').css('clip',  'rect(0px, '+OW+'px, '+OH+'px, 0px)');
      $(this).parents('.image-comapre-main').find('.twentytwenty-handle').css('left',  '0');
    });
    $(document).on('click', '.lt-tgr', function(e){
      e.preventDefault();
      $(this).parent().find('a').removeClass('active');
      $(this).addClass('active');
      var OW = $(this).parents('.image-comapre-main').outerWidth();
      var OH = $(this).parents('.image-comapre-main').outerHeight();
      $(this).parents('.image-comapre-main').find('.twentytwenty-after').css('clip',  'rect(0px, 0px, '+OH+'px, 0px)');
      $(this).parents('.image-comapre-main').find('.twentytwenty-before').css('clip',  'rect(0px, '+OW+'px, '+OH+'px, 0px)');
      $(this).parents('.image-comapre-main').find('.twentytwenty-handle').css('left',  OW);
    });

  $('.living-map-list-item h3').click(function() {
    $('.living-map-list-item h3').removeClass('on');
    $('.living-map-list-item-content').slideUp('normal');
    if($(this).next().is(':hidden') == true) {
      $(this).addClass('on');
      $(this).next().slideDown('normal');
    }
  });
  $(document).on('click', 'a[href="#enquire-now"]', function(e){
    $('html').removeClass('nav-open');
    $('html').addClass('popup-open');
  });
  $(document).on('click', '.popup-close', function(e){
    e.preventDefault();
    $('html').removeClass('popup-open');
  });
  $(document).mouseup(function(e){
    var container = $(".enquire-popup-in");
    if (!container.is(e.target) && container.has(e.target).length === 0){
        $('html').removeClass('popup-open');
    }
  });
  $(window).on('scroll', function(){
    var ST = $(this).scrollTop();
    var OH = $('.banner').outerHeight();
    if($(window).width()>= 1200){
      if(ST >= 20){
        $('.site-header').addClass('sticky');
      }else{
        $('.site-header').removeClass('sticky');
      }      
    }
    if(ST >= OH*0.5){
         $('.site-header').addClass('bg-alt');
      }else{
        $('.site-header').removeClass('bg-alt');
      }
  });

});